import React, { useContext } from "react";
import { languageKey } from "../../../constants/static";
import { legalAndPrivacyDetailsURL } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import { translations } from "../../../translate";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";

const LegalAndPrivacy: React.FC = () => {
  const { stateUSACode, cidmUrl, languageCode } = useContext(StateContext);
  const { getStateName } = utils;
  const URL = cidmUrl
    ? `${cidmUrl}${legalAndPrivacyDetailsURL(languageCode)}/${getStateName(stateUSACode)}&experience/language/${
        languageKey[languageCode]
      }`
    : "";
  const { data, loading } = useFetch<IURLAssetReference[]>(URL);
  const renderUI = () => {
    return <div>{loading ? null : <ParentFragmentHTML data={data} />}</div>;
  };
  return (
    <LegalAndPrivacyContainer title={translations.legaAndPrivacy[languageCode]}>{renderUI()}</LegalAndPrivacyContainer>
  );
};

export default LegalAndPrivacy;
